<template>
    <div class="line_list">
        <page-container class="search_bar">
            <line-search v-model="queryForm" @toSearch="toSearch" @onReset="onReset" />
        </page-container>
        <page-container class="list-table">
            <!-- <a-button
        class="create-plus"
        @click="addTemplate"
      >
        <img src="@/assets/img/icon_daoru.png" alt="">
        导入线路报价
      </a-button> -->
            <div class="active_bar">
                <a-button type="primary" @click="handleAddQuote"><i class="el-icon-plus"></i>新增报价</a-button>
            </div>
            <div class="active_bar">
                <a-button @click="handleImport">导入报价单</a-button>
            </div>
            <div class="active_bar">
                <a-button @click="handleExport">导出报价</a-button>
            </div>
            <a-table
                :columns="LINECOLUMN"
                :data-source="dataList"
                :row-key="(rec, index) => index"
                class="table-sigle"
                :loading="loading"
                :scroll="{ x: 'calc(700px + 50%)' }"
                :pagination="pagination"
                @change="tableChange"
            >
                <template slot="startWarehouse" slot-scope="text">
                    <a-tooltip placement="top">
                        <template slot="title">
                            {{ text }}
                        </template>
                        <p class="ellipsis">{{ text }}</p>
                    </a-tooltip>
                </template>
                <template slot="endWarehouse" slot-scope="text">
                    <a-tooltip placement="top">
                        <template slot="title">
                            {{ text }}
                        </template>
                        <p class="ellipsis1">{{ text }}</p>
                    </a-tooltip>
                </template>
                <template slot="approvalStatus" slot-scope="text">
                    <span>{{ text || '未审核' }}</span>
                </template>
                <template slot="loadF" slot-scope="text">
                    <span>{{ getNumber(text) }}%</span>
                </template>
                <template slot="action" slot-scope="text, record">
                    <a-button class="active_btn" type="link" @click="handleEditLog(record)">修改日志</a-button>
                    <a-button class="active_btn" type="link" @click="handleEdit(record)">编辑</a-button>
                    <a-button class="active_btn delete_btn" type="link" @click="onDelete(record)">删除</a-button>
                </template>
            </a-table>
        </page-container>
        <import-plan ref="importPlan" @cancel="handleCancel" />
        <importQuoteVue ref="importQuoteVueRef" @handleSuccess="handleSuccess" />
        <editQuoteDialog ref="editQuoteDialog" @refresh="handleRefresh" />
        <EditLogModal ref="editLogModalRef" type="line" />
    </div>
</template>

<script>
import https from '@/utils/http.js';
import store from '@/store/index';
import { setAppToken, setAppClientCode } from '@/utils/auth';
import PageContainer from '@/components/page-contanier/index.vue';
import LineSearch from './lineSearch.vue';
import { LINECOLUMN } from '../const';

import ImportPlan from './importPlan.vue';
import importQuoteVue from './importQuote.vue';
import { getQuotationList, deleteQuotation } from '../../api';
import editQuoteDialog from './editQuoteDialog.vue';
import EditLogModal from './EditLogModal'; // 编辑日志的对话框

export default {
    name: 'LineList',
    components: {
        PageContainer,
        LineSearch,
        ImportPlan,
        editQuoteDialog,
        importQuoteVue,
        EditLogModal
    },
    data() {
        return {
            queryForm: {},
            LINECOLUMN,
            dataList: [],
            pagination: {
                current: 1,
                total: 0,
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                onShowSizeChange: (current, pageSize) => {
                    this.pagination.pageSize = pageSize;
                },
                showQuickJumper: true,
                showTotal: (total) => `共 ${total} 条`
            },
            loading: false,
            export: false
        };
    },
    computed: {
        getNumber() {
            return (text) => {
                const number = (text * 100).toFixed(2);
                const arr = number.split('.');
                if (arr[1] === '00') {
                    return arr[0];
                }
                if (arr[1].endsWith(0)) {
                    return `${arr[0]}.${arr[1][0]}`;
                }
                return number;
            };
        }
    },
    created() {
        if (this.$route.path === '/smartWiring') {
            const { appToken, appClientCode, accountName, accountId, mobile, customerCode } = this.$route.query;
            if (appToken) {
                setAppToken(appToken);
            }
            if (appClientCode) {
                setAppClientCode(appClientCode);
                this.appClientCode = appClientCode;
            }
            if (accountId) {
                store.commit('user/SET_ACCOUNTID', accountId); // 账号id
            }
            if (accountName) {
                store.commit('user/SET_ACCOUNTNAME', accountName); // 组织名称
            }
            if (mobile) {
                store.commit('user/SET_MOBILE', mobile); // 组织名称
            }
            if (customerCode) {
                store.commit('user/SET_CUSTOMER_CODE', customerCode); // 货主编码
            }
        }
        console.log(888, store.state.user.customerCode);
        this.getList();
    },

    methods: {
        handleCancel() {
            this.toSearch();
        },
        toSearch() {
            this.pagination.current = 1;
            this.getList();
        },
        onReset() {
            this.queryForm = {};
            this.toSearch();
        },
        async getList() {
            const { current, pageSize } = this.pagination;
            this.loading = true;
            try {
                const res = await getQuotationList({
                    ...this.queryForm,
                    customerCode: this.$store.state.user.customerCode,
                    size: pageSize,
                    num: current - 1
                });
                this.dataList = res.data || [];
                this.pagination.total = res.total || 0;
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        addTemplate() {
            this.$refs.importPlan.show();
        },
        tableChange(pagination) {
            let { current } = pagination;
            if (pagination.pageSize !== this.pagination.pageSize) {
                current = 1;
            }
            this.pagination = {
                ...pagination,
                current
            };
            this.getList();
        },
        handleAddQuote() {
            this.$refs.editQuoteDialog.show();
        },
        handleEdit(row) {
            this.$refs.editQuoteDialog.show(row);
        },
        onDelete(row) {
            this.$confirm({
                content: '确认删除该条报价？',
                okText: '删 除',
                okType: 'danger',
                class: 'delete_bar',
                icon: () =>
                    this.$createElement('a-icon', {
                        props: {
                            type: 'info-circle',
                            theme: 'filled'
                        }
                    }),
                cancelText: '取消',
                onOk: async () => {
                    await deleteQuotation({ id: row.id });
                    this.$message.success('删除成功');
                    this.onReset();
                }
            });
        },
        handleRefresh() {
            this.onReset();
        },
        async handleExport() {
            // 导出报价
            if (this.pagination.total === 0) {
                this.$message.warning('暂无线路报价，导出失败！');
                return;
            }
            if (this.export) {
                this.$message.warning('正在导出报价，无需重复点击');
                return;
            }
            try {
                this.export = true;
                await https({
                    data: {},
                    url: `/gxzw/downloadQuotation?customerCode=${this.$store.state.user.customerCode}`,
                    service: 'BMS_BIGDATA',
                    name: '线路报价导出',
                    type: 'xlsx'
                });
                this.export = false;
                this.$message.success('导出成功！');
            } catch (e) {
                this.export = false;
            }
        },
        handleImport() {
            // 导入报价单
            this.$refs.importQuoteVueRef.show();
        },
        handleSuccess() {
            this.toSearch();
        },
        // 修改日志
        handleEditLog(data) {
            this.$refs.editLogModalRef.openModal(data);
        }
    }
};
</script>

<style lang="less" scoped>
.list-table {
    padding: 24px 0;
    .create-plus {
        border: 1px solid #25c48d;
        color: #25c48d;
        margin-bottom: 24px;
        img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
        }
        &:hover {
            border: 1px solid #009168;
            color: #009168;
        }
    }
}
.active_bar {
    margin-bottom: 24px;
    display: inline-block;
    margin-right: 12px;
}
.search_bar {
    border-bottom: 1px solid #ebedf0;
    padding: 24px 0 !important;
}
.line_list {
    padding: 0 24px;
    background: #fff;
}
.active_btn {
    padding: 0;
    margin: 0;
    &::after {
        content: '';
        width: 1px;
        height: 12px;
        background-color: #dcdee0;
        display: inline-block;
        margin: 0 8px;
    }
}
.active_btn:last-child::after {
    display: none;
}
.delete_btn {
    color: #969799;
}
.el-icon-plus {
    margin-right: 8px;
}
</style>
<style lang="less">
.delete_bar {
    .ant-modal-confirm-body {
        color: #323232;
        .anticon {
            margin-right: 8px;
        }
        .ant-modal-confirm-content {
            color: #323232 !important;
        }
    }
}
</style>
